import Vue from 'vue';

import VueGtag from 'vue-gtag'; // GA4 數據分析
import VueRouter from 'vue-router';
import checkAndRedirect from './guards/checkAndRedirect';

// https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if(onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueGtag, {
  config: {
    id: 'G-N6P570EWBC',
  },
});

import donationWay from '../views/donation/1_donationWay.vue';
import donationAmount from '../views/donation/2_donationAmount.vue';
import donationInfo from '../views/donation/3_donationInfo.vue';
import donationConfirm from '../views/donation/4_donationConfirm.vue';
import donationPayment from '../views/donation/5_donationPayment.vue';
import donationResult from '../views/donation/6_donationResult.vue';

Vue.use(VueRouter);

const routes = [
  {
    name: '404',
    path: '*',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
  },
  {
    name: 'Home',
    path: '/',
    alias: [
      '/index',
      '/home',
    ],
    component: donationAmount,
  },
  // {
  //   name: 'donation-way',
  //   path: '/way',
  //   component: donationWay,
  // },
  {
    name: 'period-amount',
    path: '/period/amount',
    component: donationAmount,
  },
  {
    name: 'period-info',
    path: '/period/info',
    component: donationInfo,
  },
  {
    name: 'period-confirm',
    path: '/period/confirm',
    component: donationConfirm,
  },
  {
    name: 'period-payment',
    path: '/period/payment',
    component: donationPayment,
  },
  {
    name: 'period-result',
    path: '/period/result',
    component: donationResult,
  },
  {
    name: 'single-amount',
    path: '/single/amount',
    component: donationAmount,
  },
  {
    name: 'single-info',
    path: '/single/info',
    component: donationInfo,
  },
  {
    name: 'single-payment',
    path: '/single/payment',
    component: donationPayment,
  },
  {
    name: 'single-confirm',
    path: '/single/confirm',
    component: donationConfirm,
  },
  {
    name: 'single-result',
    path: '/single/result',
    component: donationResult,
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "resetPassword" */ '../views/ResetPassword.vue'),
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import(/* webpackChunkName: "success" */ '../views/Success.vue'),
  },
  {
    path: '/search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue'),
    children: [
      {
        path: '/',
        name: 'SearchInfo',
        component: () => import(/* webpackChunkName: "search" */ '@/components/search/Info'),
      },
      {
        path: 'result',
        name: 'SearchResult',
        component: () => import(/* webpackChunkName: "search" */ '@/components/search/Result'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(checkAndRedirect);

export default router;
